import DrawerBody from "ds/components/Drawer/Body";
import FormFieldViewText from "components/FormFields/ViewText";
import { SamlSettings } from "types/generated";
import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";

import SettingsSingleSignOnConfigInfoSAML from "../components/ConfigInfoSAML";
import ClaimMappingsTable from "../components/ClaimMappingsTable";
import { SAML_NAME_ID_FORMATS_DICTIONARY } from "./constants";

type SettingsSingleSignOnDetailsSAMLProps = {
  integration: SamlSettings;
};

const SettingsSingleSignOnDetailsSAML = ({ integration }: SettingsSingleSignOnDetailsSAMLProps) => {
  const hasClaimMappings = integration.claimMapping.entries.length > 0;

  return (
    <>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="SAML SSO" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody hasDivider gap="x-large" shrink="0">
        <SettingsSingleSignOnConfigInfoSAML />
        <FormFieldViewText label="Admin login" value={integration.adminLogin} withCopy noMargin />
        <FormFieldViewText
          label="NameID Format"
          value={SAML_NAME_ID_FORMATS_DICTIONARY[integration.nameIDFormat]}
          withCopy
          noMargin
        />
        {integration.idpMetadata && (
          <FormFieldViewText
            label="IdP metadata"
            value={integration.idpMetadata}
            withCopy
            noMargin
          />
        )}
        {integration.idpMetadataURL && (
          <FormFieldViewText
            label="IdP metadata URL"
            value={integration.idpMetadataURL}
            withCopy
            noMargin
          />
        )}
      </DrawerBody>

      {hasClaimMappings && (
        <DrawerBody gap="x-large">
          <Box direction="column" gap="large" fullHeight>
            <Typography variant="p-t6" tag="h3">
              Claim Mappings
            </Typography>
            <ClaimMappingsTable mappings={integration.claimMapping.entries} />
          </Box>
        </DrawerBody>
      )}
    </>
  );
};

export default SettingsSingleSignOnDetailsSAML;
